module.exports = __webpack_public_path__ + "static/media/15.1f39411b.jpg";